export default "__VITE_ASSET__XlYeCOHh__"